import { Col, Row } from "antd";
import type { FC } from "react";

import { fullWidthComponents } from "../../../oldSrc/oldComponents/Form/GenericForm/GenericForm";
import type { FormFieldRenderProps } from "../types";
import { ConditionalWrapper } from "./ConditionalWrapper/ConditionalWrapper";
import { getValidationRules } from "./Validations/ValidationFieldsFactory";

export const FormFieldRender: FC<FormFieldRenderProps> = ({ factory, field, readOnly, onChange, readOnlyField, isVisible }) => {
    const rules = getValidationRules(field.attributes?.validationRules);

    // check if the RO field is RO
    const isROFieldRO = readOnlyField && readOnlyField.attributes?.readOnly === true;

    const fieldComponent = factory({
        field,
        readOnly,
        rules,
        changeCallback: onChange,
    });
    const fieldComponentRO = !readOnlyField
        ? null
        : factory({
              field: readOnlyField,
              readOnly: isROFieldRO || readOnly,
              changeCallback: onChange,
          });

    const isFullWidth = fullWidthComponents.filter((c) => c === field?.component).length > 0;

    return (
        <ConditionalWrapper key={`${field.name}-wrapper`} fieldConfig={field}>
            <Row gutter={20} hidden={!isVisible}>
                {isFullWidth ? (
                    <Col span={24}>{fieldComponent}</Col>
                ) : (
                    <>
                        <Col span={14}>{fieldComponent}</Col>
                        <Col span={8}>{fieldComponentRO}</Col>
                    </>
                )}
            </Row>
        </ConditionalWrapper>
    );
};
